<template>
  <div
    id="aboutus">
    <v-layout
      row
      wrap>
      <v-flex
        data-aos="fade-up"
        xs12
        sm6
        md6>
        <v-layout
          column
          align-center>
          <v-card
            flat
            tile
            class="img-icon-aboutus"
            img="/img/icons/serynge-icon.png"
          ></v-card>
          <p
            class="aboutus-title">
            Laparoscopia
          </p>
          <p
            class="aboutus-description">
            Advanced laparoscopy, Texas Endosurgery Institute
          </p>
        </v-layout>
      </v-flex>
      <v-flex
        data-aos="fade-up"
        xs12
        sm6
        md6>
        <v-layout
          column
          align-center>
          <v-card
            flat
            tile
            class="img-icon-aboutus"
            img="/img/icons/key-icon.png"
          ></v-card>
          <p
            class="aboutus-title">
            Cirugía Colorectal
          </p>
          <p
            class="aboutus-description">
            Colorectal Surgery Fellow, Uninversity of Texas, HSC at San Antonio, Texas
          </p>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="$vuetify.breakpoint.mdAndUp"
        style="margin-top: 40px"
        xs12
        sm12
        md12
      ></v-flex>
      <v-flex 
        data-aos="fade-left"
        xs12
        sm6
        md4>
        <v-layout
          column
          align-center>
          <v-card
            flat
            tile
            class="img-icon-aboutus"
            img="/img/icons/pill-icon.png"
          ></v-card>
          <p
            class="aboutus-title">
            Cirugía General
          </p>
          <p
            class="aboutus-description">
            General Surgery, ITESM School of Medicine
          </p>
        </v-layout>
      </v-flex>
      <v-flex
        data-aos="fade-up"
        xs12
        sm6
        md4>
        <v-layout
          column
          align-center>
          <v-card
            flat
            tile
            class="img-icon-aboutus"
            img="/img/icons/heart-icon.png"
          ></v-card>
          <p
            class="aboutus-title">
            Medicina Familiar
          </p>
          <p
            class="aboutus-description">
            Family Physician, University of Tamaulipas, IMSS
          </p>
        </v-layout>
      </v-flex>
      <v-flex
        data-aos="fade-right"
        xs12
        sm6
        md4>
        <v-layout
          column
          align-center>
          <v-card
            flat
            tile
            class="img-icon-aboutus"
            img="/img/icons/band-aid-icon.png"
          ></v-card>
          <p
            class="aboutus-title">
            Basic Medicine
          </p>
          <p
            class="aboutus-description">
            Basic Med School, University of Tamaulipas
          </p>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  
}
</script>
<style scoped>
  .aboutus-description {
    text-align: center;
    font-size: 18px;
    font-family: 'Roboto', sans-serif;
    align-self: center;
    max-width: 60%;
  }
  .img-icon-aboutus {
    width: 180px;
    height: 180px;
    align-self: center;
  }
  .aboutus-title {
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    font-family: 'Roboto', sans-serif;
  }
  #aboutus {
    padding-top: 50px;
    padding-bottom: 100px;
    padding-left: 10%;
    padding-right: 10%;
    background-color: white;
    position: relative;
    z-index: 2;
    height: auto; 
  }
</style>